<template>
    <v-container>
        <v-container style="display: flex; justify-content: space-between;">
            <h2>Relatório de Inspeção e Diligenciamento</h2>
        </v-container>
        <v-container class="d-flex justify-space-between pa-0 align-center" :class="themeClass">
          <v-tabs v-model="activeTab" style="width: auto;">
            <v-tab><v-icon>mdi-table</v-icon>RID</v-tab>              
            <!-- <v-tab>Dashboard</v-tab> -->
          </v-tabs>
          <v-text-field
            v-model="searchText"
            label="Pesquisa"
            prepend-icon="mdi-magnify"
            @input="search"
            dense
            style="width: 100%;"
            class="ml-2 mr-2 align-end"
          ></v-text-field>
          <v-btn @click="setIsOpenModal" style="box-shadow: none; height: 30px; margin: 0px 8px; background-color: blue; color: white !important;" small>
            Adicionar <v-icon style="margin-left: 4px;">mdi-plus</v-icon>
          </v-btn>
          <v-btn @click="setIsOpenFilterDialog" style="box-shadow: none; border: 1px solid #e1e1e1; height: 30px; margin: 0px 8px; background-color: white; color: black !important;" small>
            <v-icon style="margin-left: 4px;">mdi-tune-vertical</v-icon>Filtros
          </v-btn>
        </v-container>
        <v-tabs v-model="activeTab">
          <v-container class="d-flex justify-start flex-wrap" v-if="activeTab === 0">
            <template v-for="(filter, key) in filters">
              <v-btn 
                v-if="filter.value" 
                :key="key" 
                style="box-shadow: none; height: 30px; margin: 0px 8px;" 
                small 
                @click="clearFilter(key)"
              >
                {{ filter.label }}: {{ filter.value }}
                <v-icon small class="ml-1">mdi-close</v-icon>
              </v-btn>
            </template>
          </v-container>
        </v-tabs>
        <v-data-table
            :headers="headers"
            :items="items"
            class="elevation-1"
            disable-sort
            :single-expand="false"
        >
          <template v-slot:[`item.lastColumn`]="{ item }">
            <v-container class="d-flex">
              <v-btn
                icon
                v-if="item.createBy === userEmail"
                @click="setIsOpenEditModal(item.id)"
              >
                <v-icon>{{ item ? 'mdi-pencil' : '' }}</v-icon>
              </v-btn>
              <v-btn
                icon
                @click="generatedDefinitionPdf(item)"
              >
                <v-icon >{{ item ? 'mdi-download' : '' }}</v-icon>
              </v-btn>
            </v-container>
          </template>
        </v-data-table>

        <v-dialog v-model="filterDialog" max-width="600" class="filterDialog">
          <v-card>
            <v-container class="dialogTitle d-flex justify-space-between align-center">
              <v-card-title :class="themeClass" class="headline text-h6 font-weight-bold">
                <v-icon>mdi-tune-vertical</v-icon>
                Filtros
              </v-card-title>
              <v-btn class="filter_button" color="red" dark @click="clearAllFilters">
                <v-icon>mdi-trash-can-outline</v-icon>
                Limpar
              </v-btn>
            </v-container>
            
            <v-card-text>
              <v-form ref="filterForm">
                <v-row dense>
                  <v-col v-for="(filter, key) in filters" :key="key" cols="12" md="6">
                    <v-combobox 
                      v-if="filter.type === 'combobox'"
                      v-model="filter.value"
                      :items="filter.items"
                      :label="filter.label"
                      dense outlined 
                    />
                    <v-text-field 
                      v-else-if="filter.type === 'text'"
                      v-model="filter.value"
                      :label="filter.label"
                      dense outlined 
                    />
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
          </v-card>
        </v-dialog>

        <CreateRID :value="isModalOpen" @close="isModalOpen=false" :code="codeAutoInc" />
        <EditRID :value="isEditModalOpen" @close="isEditModalOpen=false" :id="id" :refreshRID="getRID"/>
    </v-container>
  </template>
  
  <script>
  import Vue from 'vue';
  import CreateRID from "./RIDCreateView.vue"
  import EditRID from './RIDEditView.vue'
  import { width } from 'cli-color/window-size';
  import jsPDF from "jspdf";

  export default {
    components: {
      CreateRID,
      EditRID
    },
    data() {
      return {
        isEditModalOpen: false,
        userEmail: '',
        itemToDelete: null, 
        activeTab: 0,
        isModalOpen: false,
        id: '',
        osCodigo: '',
        codeAutoInc: '',
        itemsPerPage: 50, // Limite inicial de itens por página
        currentPage: 1, // Página inicial
        statusOptions: ['LA', 'SC', 'SF', 'ET', 'EP', 'AA', 'GP', 'RE'],
        filterDialog: false, // Controle do modal de filtros
        filters: {
          pedidoDeCompraCodigo: { value: '', label: 'Pedido de Compra', items: this.filterPedidoDeCompra, type: 'combobox' },
          job: { value: '', label: 'JOB', items: this.jobOption, type: 'combobox' },
          rid: { value: '', label: 'Número do RID', type: 'text' },
          inspetor: { value: '', label: 'Nome do Inspetor', items: this.inspectorOptions, type: 'combobox' },
        },
        tab: null,
        headers: [
          { text: "Código", value: "code", width: '100px' },
          { text: "Tipo", value: "type", width: '150px' },
          { text: "Fornecedor", value: "supplierCorporateReason", width: '100px' },
          { text: "Data", value: "date", width: '100px' },
          { text: "JOB", value: "jobCode", width: '180px' },
          { text: "Cliente", value: "client", width: '180px' },
          { text: "Local", value: "location", width: '100px' },
          { text: "Contato", value: "contact", width: '180px' },
          { text: "Setor", value: "sector", width: '150px' },
          { text: "Telefone", value: "phone", width: '150px' },
          { text: "Técnico", value: "technician", width: '150px' },
          { text: "Coordenador", value: "coordinator", width: '150px' },
          // { text: "Items", value: "items", width: '180px' },
          { text: "", value: "lastColumn", width: "100px" }
        ],
        items: [],
        customItemsPerPageOptions: [
            { title: '50', value: 50 },
            { title: '100', value: 100 },
            { title: '150', value: 150 },
            { title: '200', value: 200 }
        ], // Opções de limite
      };
    },
    computed: {
      themeClass() {
        return this.$vuetify.theme.dark ? 'dark-theme' : 'light-theme';
      },
    },
    methods: { 

      async getTenanty(){
        const lc = window.localStorage.getItem("user-login");
        const user = JSON.parse(lc);
        this.userEmail = user[1];
      },

      async getBase64FromUrl(url) {
        const data = await fetch(url);
        const blob = await data.blob();
        return new Promise((resolve) => {
          const reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onloadend = () => {
            const base64data = reader.result;
            resolve(base64data);
          }
        });
      },

      clearFilter(key) {
        if (this.filters[key]) {
          this.filters[key].value = null; // Reseta apenas o valor do filtro
        }
      },

      setIsOpenFilterDialog() {
        this.filterDialog = !this.filterDialog;
      },

      // Abre o modal de filtros
      async setIsOpenModal() {
        let req = await Vue.prototype.$http.get(`/Entity/AutoInc`, { params: { schemaName: "RID", field: "Code", mask: "#####"}});
        this.codeAutoInc = req.data;
        this.isModalOpen = !this.isModalOpen;
      },
      
      async setIsOpenEditModal(id) {
        this.id = id;
        this.isEditModalOpen = !this.isEditModalOpen;
      },

      async getRID() {

        let searchFields = [];
        let values = [];

        // Adicione os campos e valores com base na presença de dados
        if (this.filters.rid.value) {
            searchFields.push('code');
            values.push(this.filters.rid.value.toString());
        }
        if (this.filters.pedidoDeCompraCodigo.value) {
            searchFields.push('purchaseOrderCode');
            values.push(this.filters.pedidoDeCompraCodigo.value.toString());
        }
        if (this.filters.job.value) {
            searchFields.push('jobcode');
            values.push(this.filters.job.value.toString());
        }

        // Converta os arrays para strings separadas por vírgulas
        searchFields = searchFields.join(',');
        values = values.join(',');

        // Faça a requisição com os parâmetros ajustados
        let req = await Vue.prototype.$http.get(`/Entity/RID/search-fields`, {
            params: {
                value: values, // Valores de filtros passados
                page: this.currentPage,
                limit: this.itemsPerPage,
                searchFields: searchFields // Campos de filtro que possuem valores
            }
        });

        this.items = req.data.data.data;

        this.filters.job.items = [...new Set(this.items.map(item => item.jobCode))];
        this.filters.pedidoDeCompraCodigo.items = [...new Set(this.items.map(item => item.purchaseOrderCode))];
        
        console.log(this.filters)
        // console.log(req.data.data.data)

      },

      getDate(date){
        return new Date(date).toLocaleDateString()
      },

      async viewRun(id) {

        let params = [{
          dataType: "String",
          name: "id",
          value: id
        }]
        const data = await this.$viewService.viewRun("get-rid-by-id", 1, params);
        let result = data.data.data.data[0]

        console.log("RESULT >>> ", result)
        return result;
      },

      async getRidItems(id){

        let req = await Vue.prototype.$http.get(`/Entity/RID/search-items`, { params: { page: 1, limit: 1000, id: id, relationSchema: 'RIDOsItens' }});
        let result = req.data.data.data;

        return result;
      },

      async generatedDefinitionPdf(item) {

        console.log("ITEM >>> ", item)

        // await this.getRidItems(item?.id)
        let viewResult = await this.viewRun(item?.id)

        let ridItems = viewResult?.items || []
        let osItems = viewResult?.items?.map((viewItem) => viewItem?.osItem[0])
        
        let inspectionScope = item?.inspectionScope?.split(';') || []
        let documentReference = item?.referenceDocuments.trim() ? JSON.parse(item?.referenceDocuments) : {}
        let inspectionDetails = item?.referenceDocuments.trim() ? JSON.parse(item?.inspectionDetails) : {}
        let ocurrenceRecord = item?.ocurrenceRecord ? item?.ocurrenceRecord : {}
        let results = item?.results.trim() ? JSON.parse(item?.results) : {}

        let columnsInspectionDetails = []
        let columnsInspectionScope = []
        let columnsDocumentReference = []
        let columnsOsItens = []
        let columnsItensRid = []
        let columnsOcurrenceRecord = []
        let columnsResults = []

        let evidenceImages = await Promise.all(
          (viewResult?.imagens_id || []).map(async (image) => {
            let imageBase64 = await this.getBase64FromUrl(image?.image[0]);
            return {
              description: image.description,
              imageBase64: imageBase64
            };
          })
        );

        let rowsImages = [];
        if (evidenceImages?.length > 0) {
          for (let i = 0; i < evidenceImages.length; i += 3) {
            let slicedImages = evidenceImages.slice(i, i + 3);

            // Garante que sempre haja 3 colunas
            while (slicedImages.length < 3) {
              slicedImages.push({}); // Adiciona um objeto vazio
            }

            let row = slicedImages.map((img) => {
              if (img.imageBase64) {
                return [
                  { image: img.imageBase64, width: 150, height: 150, alignment: "center" },
                  { text: img.description || "", alignment: "center", fontSize: 10, margin: [0, 0, 0, 5] }
                ];
              } else {
                return [{ text: "", colSpan: 2 }];
              }
            });

            rowsImages.push(row);
          }
        }

        columnsOsItens.push([
          { text: 'ITEM', style: 'tableHeader', fontSize: 7 },
          { text: 'DESCRIÇÃO', style: 'tableHeader', fontSize: 7 },
          { text: 'N° PC', style: 'tableHeader', fontSize: 7 },
          { text: 'Prazo PC', style: 'tableHeader', fontSize: 7 },
          { text: 'OS', style: 'tableHeader', fontSize: 7 },
          { text: 'Quantidade', style: 'tableHeader', fontSize: 7 },
          { text: 'Aprovação', style: 'tableHeader', fontSize: 7 }
        ])

        if(osItems?.length > 0){
          osItems?.map((itemOs, index) => {
            columnsOsItens.push([
              { text: itemOs?.sequencia, fontSize: 7, alignment: 'center' },
              { text: itemOs?.descricao, fontSize: 7, alignment: 'center' },
              { text: viewResult?.purchaseOrderCode, fontSize: 7, alignment: 'center' },
              { text: "", fontSize: 7, alignment: 'center' },
              { text: itemOs?.itemCodigo, fontSize: 7, alignment: 'center' },
              { text: itemOs?.quantidade, fontSize: 7, alignment: 'center' },
              { text: ridItems[index]?.approve ? "SIM" : "NÃO", fontSize: 7, alignment: 'center' }
            ])
          })
        }

        columnsItensRid.push([
          { text: 'OS', style: 'tableHeader', fontSize: 7 },
          { text: 'QTDE', style: 'tableHeader', fontSize: 7 },
          { text: 'DESCRIÇÃO', style: 'tableHeader', fontSize: 7 },
          { text: 'PESO', style: 'tableHeader', fontSize: 7 },
          { text: 'MP', style: 'tableHeader', fontSize: 7 },
          { text: 'PREP.', style: 'tableHeader', fontSize: 7 },
          { text: 'MONT.', style: 'tableHeader', fontSize: 7 },
          { text: 'SOLD.', style: 'tableHeader', fontSize: 7 },
          { text: 'PINTURA', style: 'tableHeader', fontSize: 7 },
          { text: 'INSPEÇÃO', style: 'tableHeader', fontSize: 7 }
        ])

        if(ridItems?.length > 0){
          ridItems?.map((ridItem, index) => {
            columnsItensRid.push([
              { text: osItems[index]?.itemCodigo, fontSize: 7, alignment: 'center' },
              { text: osItems[index]?.quantidade, fontSize: 7, alignment: 'center' },
              { text: osItems[index]?.descricao, fontSize: 7, alignment: 'center' },
              { text: ridItem?.peso, fontSize: 7, alignment: 'center' },
              { text: ridItem?.mp, fontSize: 7, alignment: 'center' },
              { text: ridItem?.prep, fontSize: 7, alignment: 'center' },
              { text: ridItem?.mont, fontSize: 7, alignment: 'center' },
              { text: ridItem?.sold, fontSize: 7, alignment: 'center' },
              { text: ridItem?.pintura, fontSize: 7, alignment: 'center' },
              { text: ridItem?.inspecao, fontSize: 7, alignment: 'center' },
            ])
          })
        }

        if(documentReference && Object.entries(documentReference).length > 0){
          Object.entries(documentReference)?.map((doc) => {
            columnsDocumentReference.push([
              { text: `${doc[1] || ''}`, fontSize: 10 }
            ])
          })
        }

        if(inspectionScope.length > 0){
          inspectionScope?.map((inspection) => {
            columnsInspectionScope.push([
              { text: inspection || "", fontSize: 10 }
            ])
          })
        }

        if(inspectionDetails && Object.entries(inspectionDetails).length > 0){
          Object.entries(inspectionDetails)?.map(([key, value]) => {
            columnsInspectionDetails.push([
              { text: key || '', fontSize: 10 }, 
              { ul: [{ text: value || '', fontSize: 10 }] } 
            ]);
          });
        }

        if(results && Object.entries(results).length > 0){
          Object.entries(results)?.map(([key, value]) => {
            columnsResults.push([ {text: `${key}: ${value}`, fontSize: 10 } ])
          })
        }

        console.log(columnsResults)

        var definition = {
          content: [
            {
              table: {
                widths: ['20%', '*'],
                body: [
                  [
                    {
                      image: 'data:image/jpeg;base64,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',
                      width: 70, alignment: 'center', margin: [0, 0]
                    },

                    { margin: [0, 30], text: `Relatório de Inspeção e Diligenciamento - RID N ${item?.code}`, fontSize: 14, bold: true, alignment: "center" },


                  ],
                ]
              }
            },

            {
              table: {
                widths: ['*'],
                body: [
                  [{ text: 'TIPO DE RELATORIO', alignment: 'center' }],
                ]
              }
            },
            
            {
              table: {
                widths: ['*', '5%', '*', '5%', '*', '5%', '*', '5%'],
                body: [
                  [
                    { text: 'Parcial', style: 'boldText', alignment: 'center' },
                    { text: item?.type == 'Parcial' ? 'X' : '', alignment: 'center' },
                    { text: 'Final', style: 'boldText', alignment: 'center' },
                    { text: item?.type == 'Final' ? 'X' : '', alignment: 'center' },
                    { text: 'Diligenciamento', style: 'boldText', alignment: 'center' },
                    { text: item?.type == 'Diligenciamento' ? 'X' : '', alignment: 'center' },
                    { text: 'Embarque', style: 'boldText', alignment: 'center' },
                    { text: item?.type == 'Embarque' ? 'X' : '', alignment: 'center' }
                  ]
                ]
              }
            },

            {
              table: {
                widths: ['67.3%', '*'],
                body: [
                  [
                      {
                        columns: [{ text: "Fornecedor", bold: true }, {text: item?.supplierCorporateReason}],
                      },
                      {
                        columns: [{ text: "Data", bold: true }, {text: item?.date ? new Date(item?.date)?.toLocaleDateString() : '', color: 'black' }],
                      },
                  ],
                ]
              }
            },

            {
              table: {
                widths: ['*', '*', '*'],
                body: [
                  [
                      {
                        columns: [{ text: "Encomenda/JOB", bold: true, fontSize: 9 }, {text: item?.jobCode, alignment: 'center', fontSize: 9, color: 'black'}],
                      },
                      {
                        columns: [{ text: "Cliente", bold: true, fontSize: 9 }, {text: item?.client, alignment: 'center', fontSize: 9, color: 'black'}],
                      },
                      {
                        columns: [{ text: "Local", bold: true, fontSize: 9 }, {text: item?.location, alignment: 'center', fontSize: 9, color: 'black' }],
                      },
                  ],
                ]
              }
            },

            {
              table: {
                widths: ['*', '*', '*', '*'],
                body:[
                  [
                    { text: 'Contato', bold: true, style: 'boldText', alignment: 'center', },
                    { text: 'Visto', bold: true, style: 'boldText', alignment: 'center',},
                    { text: 'Setor', bold: true, style: 'boldText', alignment: 'center' },
                    { text: 'Telefone', bold: true, style: 'boldText', alignment: 'center' }
                  ],
                  [
                    { text: item?.contact, alignment: 'center', fontSize: 9 },
                    { text: item?.contactSignature, alignment: 'center', fontSize: 9 },
                    { text: item?.sector, alignment: 'center', fontSize: 9 },
                    { text: item?.phone, alignment: 'center', fontSize: 9 },
                  ]
                ]
              }
            },

            {
              table: {
                widths: ['*', '*', '*'], // Mantém as colunas com o mesmo tamanho
                body: [
                  [
                    { text: 'Tecnico', bold: true, style: 'boldText', alignment: 'center' },
                    { text: 'Visto', bold: true, style: 'boldText', alignment: 'center' },
                    { text: 'Coordenador', bold: true, style: 'boldText', alignment: 'center' }
                  ],
                  [
                    { text: item?.technician, alignment: 'center', fontSize: 9 },
                    { text: item?.technicianSignature, alignment: 'center', fontSize: 9 },
                    { text: item?.coordinator, alignment: 'center', fontSize: 9 }
                  ]
                ]
              }
            },

            {
              table: {
                widths: ['10%', '40%', '10%', '10%', '10%', '10%', '10%'],
                body: columnsOsItens,
              }
            },
            '\n',
            '\n',

            {
              text: "1. Status de fabricação:",
              bold: true,
            },
            '\n',
            {
              table: {
                widths: ['7%', '7%', '*', '7%', '7%', '7%', '7%', '7%', '7%', '7%'],
                body: columnsItensRid,
              }
            },
            '\n',
            '\n',
            { text: '2. Documentos de Referência:', bold: true, margin: [0, 0, 0, 5] },
            {
              table: {
                widths: ['100%'], // Define a largura da única coluna
                body:
                  //[{ text: 'TÍTULO', bold: true, alignment: 'center' }], // Cabeçalho da tabela
                  columnsDocumentReference.length > 0 ? columnsDocumentReference : [{ text: "Sem Documentos de Referencia", colSpan: 3, alignment: "center", fontSize: 12 }]
                  // [{ 
                  //   text: 'ETP-21-12798-01_R1 - Especificação Técnica de Pintura', 
                  //   color: 'black', 
                  //   background: 'yellow' 
                  // }],
                  // [{ 
                  //   text: 'PIT-21-12798-01_R1 - Plano de Inspeção Testes', 
                  //   color: 'black', 
                  //   background: 'yellow' 
                  // }]
                
              }
            },
            '\n',
            '\n',
            { text: '3. Escopo de Inspeções:', bold: true, margin: [0, 0, 0, 5] },
            {
              table: {
                widths: ['100%'],
                body: columnsInspectionScope.length > 0 ? columnsInspectionScope 
                  : [{ text: "", alignment: "center", fontSize: 12 }]
              }
            },

            '\n',
            '\n',
            { text: '4. Detalhes da inspeção:', bold: true, margin: [0, 0, 0, 5] },
            {
              ul: columnsInspectionDetails.length > 0 ? columnsInspectionDetails 
                : [{ text: "Não Contem Detalhes da Inspeção", colSpan: 3, alignment: "center", fontSize: 12 }]
            },

            '\n',
            '\n',
            { text: '5. Resultados:', bold: true, margin: [0, 0, 0, 5] },
            {
              ul: columnsResults.length > 0 ? columnsResults : [{ text: "Sem Resultados", colSpan: 3, alignment: "center", fontSize: 12 }]
              
            },
            
            '\n',
            '\n',
            { text: '6. Registro de Ocorrências:', bold: true, margin: [0, 0, 0, 5] },
            { text: ocurrenceRecord, bold: false, margin: [0, 0, 0, 5] },

            '\n',
            '\n',
            { text: "7. Evidências Fotográficas:", bold: true },

            {
              table: {
                widths: ["*", "*", "*"], // 3 colunas por linha
                body: rowsImages.length > 0 ? rowsImages : [
                  [{ text: "Sem Imagens", colSpan: 3, alignment: "center", fontSize: 12 }],
                ]
              },
            },

            '\n',
            '\n',
            {
              table: {
                widths: ['*', '*', '*'], // 3 colunas de tamanho igual
                body: [
                  // Linha de cabeçalho
                  [
                    { text: 'Inspetor', bold: true, alignment: 'center' },
                    { text: 'Fornecedor', bold: true, alignment: 'center' },
                    { text: 'Cliente', bold: true, alignment: 'center' }
                  ],

                  [
                    { text: `Nome: ${item?.technician}`, bold: true, alignment: 'start' },
                    { text: `Nome: ${item?.supplierCorporateReason}`, bold: true, alignment: 'start' },
                    { text: 'Nome: ', bold: true, alignment: 'start' }
                  ],
                  // Linha de espaço em branco para assinaturas
                  [
                    { text: '\n\n\n', alignment: 'center' }, // Espaço em branco para assinatura do Inspetor
                    { text: '\n\n\n', alignment: 'center' }, // Espaço em branco para assinatura do Fornecedor
                    { text: '\n\n\n', alignment: 'center' }  // Espaço em branco para assinatura do Cliente
                  ],
                  // Linha de datas
                  [
                    { text: `Data: ${item?.date ? new Date(item?.date)?.toLocaleDateString() : ''}`, alignment: 'start', fontSize: 9 }, // Data do Inspetor
                    { text: `Data: ${item?.date ? new Date(item?.date)?.toLocaleDateString() : ''}`, alignment: 'start', fontSize: 9 }, // Data do Fornecedor
                    { text: `Data:`, alignment: 'start', fontSize: 9 }  // Data do Cliente
                  ]
                ]
              },
              margin: [0, 20, 0, 10] // Margem superior e inferior
            }

          ],
          styles: {
            header: { fontSize: 16, bold: true },
            subheader: { fontSize: 14, bold: true },
            boldText: { fontSize: 12, bold: true },
            tableHeader: { bold: true, fillColor: '#CCCCCC', alignment: 'center' }
          }
        };


        await this.pdfPrinter(definition, "RID")
      },

      async pdfPrinter(definition, name) {
				var pdfMake = require("pdfmake/build/pdfmake.js");
				var pdfFonts = await require("pdfmake/build/vfs_fonts.js");

				pdfMake.vfs = pdfFonts.pdfMake.vfs;
				pdfMake.createPdf(definition).download(name);

			}
      // Aplica os filtros (exemplo: atualiza itens da tabela)
    },
    watch: {
      'filters.rid.value': function () {
        this.getRID();
      },
      'filters.pedidoDeCompraCodigo.value': function () {
        this.getRID();
      },
      'filters.job.value': function () {
        this.getRID();
      },
      'filters.inspetor.value': function () {
        this.getRID();
      }
    },
    created() {
      this.getRID();
      this.getTenanty();
    }
  };
  </script>
  <style scoped>
  
    .v-data-table thead th,
    .v-data-table tbody td {
      text-overflow: ellipsis; /* Trunca textos longos */
      white-space: nowrap;
      overflow: hidden;
    }
  
    ::-webkit-scrollbar {
      height: 5px !important;
    }
  
    ::-webkit-scrollbar-thumb {
      background-color: #230BC1 !important;
    }
  
    .v-data-table--dense > .v-data-table__wrapper > table > thead > tr > th {
      height: 48px;
      border-bottom: 0;
    }
  
    .v-application--is-ltr .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
      text-align: center !important;
      border-bottom: 0 !important;
    }
  
    .statusTd {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      height: 53px !important;
    }
  
    .activeCircle {
      border: 1px solid rgb(197, 167, 34);
      border-radius: 100%; 
      height: 0.5rem; 
      width: 0.5rem; 
      opacity: 80%; 
      background-color: rgb(34 197 94);
    }
  
    .inactiveCircle {
      border: 1px solid rgb(197, 167, 34);
      border-radius: 100%; 
      height: 0.5rem; 
      width: 0.5rem; 
      opacity: 80%; 
      background-color: #F00;
    }
  
    .v-application .elevation-1 {
      box-shadow: none !important;
    }
  
    .mdi-arrow-up::before {
      font-size: 15px !important;
    }
  
    .mdi-arrow-up::after {
      font-size: 15px !important;
    }
  
    .actionIcon {
      font-size: 18px !important;
    }
  
    .v-text-field--outlined fieldset {
      border: 0;
      border-bottom: 1px solid black;
      border-radius: 0;;
    }
  
    .v-text-field--outlined .v-text-field__slot {
      align-items: end !important;
    }
  
    .v-text-field .v-input__slot {
      padding: 0 !important;
    }
  
    .filterInput {
      outline: none;
      border: 1px solid #e1e1e1;
      color: #000;
      border-radius: 4px;
      margin-right: 18px;
      width: 269px;
      padding-left: 10px;
      font-size: 12px;
      height: 40px;
    }
  
    .theme--dark > .filterInput {
      outline: none;
      border: 1px solid #e1e1e1;
      color: #FFF !important;
      border-radius: 4px;
      margin-right: 18px;
      width: 269px;
      padding-left: 10px;
      font-size: 12px;
      height: 40px;
    }
  
    .filterInputDate {
      outline: none;
      border: 1px solid #666;
      border-radius: 4px;
      margin-right: 18px;
      width: 269px;
      padding-left: 10px;
      font-size: 12px;
      height: 40px;
    }
  
    input[type="date"]::-webkit-calendar-picker-indicator {
      cursor: pointer;
      border-radius: 4px;
      margin-right: 2px;
      opacity: 0.6;
      filter: invert(0.8);
    }
  
    .container {
      margin-right: 0;
      margin-left: 0;
      max-width: 100%;
    }
    
    .theme--dark > .dialogTitle {
      color: #000;
    }
  
     .dark-theme {
      background-color: #1E1E1E;
    }
  
    .v-slide-group__prev, .v-slide-group__prev--disabled {
      display: none !important;
    }
  
    .v-slide-group__next--disabled, .v-slide-group__prev--disabled {
      display: none !important;
    }
  
    .dark-theme {
      color: white;
    }
  
    .light-theme {
      color: #666;
    }

    .addButton {
      display: flex;
      gap: "12px"
    }

    ::v-deep(.v-data-table td) {
      overflow: hidden !important;
    }

    ::v-deep(.v-text-field__details) {
      display: none !important;
    }
  </style>